// extracted by mini-css-extract-plugin
export default {"grid":"GridBenefits_grid__XWksG"};